
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { NotificationDispatcher } from '@/app/common/services/notification-dispatcher.service'
import { Inject } from 'vue-property-decorator'
import { Consumer } from '@/app/identity'

@Component
export default class CommunicationPreferences extends Vue {
    @Prop({ type: Object }) user!: Consumer

    commercialConsent: boolean = false
    contactMethods = {
        email: false,
        phone: false,
        post: false
    }
    private isUpdatingFromContactMethods = false
    private isInitializing = false

    setAllContactMethods(value: boolean) {
        this.contactMethods.email = value;
        this.contactMethods.phone = value;
        this.contactMethods.post = value;
    }

    @Watch('commercialConsent')
    onCommercialConsentChange(newVal: boolean) {
        if (!this.isUpdatingFromContactMethods && !this.isInitializing) {
            this.setAllContactMethods(newVal);
        }
    }

    @Watch('contactMethods', { deep: true })
    onContactMethodsChange() {
        if (this.isInitializing) return;
        
        const anyEnabled = this.contactMethods.email || this.contactMethods.phone || this.contactMethods.post;
        const allDisabled = !this.contactMethods.email && !this.contactMethods.phone && !this.contactMethods.post;

        if (anyEnabled && !this.commercialConsent) {
            this.isUpdatingFromContactMethods = true;
            this.commercialConsent = true;
            this.$nextTick(() => {
                this.isUpdatingFromContactMethods = false;
            });
        } else if (allDisabled && this.commercialConsent) {
            this.isUpdatingFromContactMethods = true;
            this.commercialConsent = false;
            this.$nextTick(() => {
                this.isUpdatingFromContactMethods = false;
            });
        }
    }

    @Inject() notificationDispatcher!: NotificationDispatcher
    @Inject() updateMarketingCampaignPreferenceCommand!: any

    mounted() {
        this.initializePreferences()
    }

    initializePreferences() {
        this.isInitializing = true;
        const pref = this.user?.marketingCampaignPreference
        if (pref) {
            this.contactMethods.email = pref.email
            this.contactMethods.phone = pref.phone
            this.contactMethods.post = pref.post
            this.commercialConsent = pref.enabled
        }
        this.$nextTick(() => {
            this.isInitializing = false;
        });
    }

    @Watch('user', { deep: true })
    onUserChange() {
        this.initializePreferences()
    }

    async savePreferences() {
        const updatedPreferences = {
            consumer_api_id: this.user.id,
            enabled: this.commercialConsent,
            email: this.contactMethods.email,
            phone: this.contactMethods.phone,
            post: this.contactMethods.post
        }
        await this.updateMarketingCampaignPreferenceCommand.run(updatedPreferences)

        const updatedConsumer = new Consumer({
            ...this.user,
            marketingCampaignPreference: {
                enabled: updatedPreferences.enabled,
                email: updatedPreferences.email,
                phone: updatedPreferences.phone,
                post: updatedPreferences.post
            }
        })

        await this.$store.dispatch('auth/updateConsumer', updatedConsumer)
        await this.notificationDispatcher.success(this.$t('page.communication_preference.success_message') as string)
    }
}
